import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { mockInstagramPosts } from '@/mocks/travel';

gsap.registerPlugin(ScrollTrigger);

export default function InstagramSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const cards = sectionRef.current?.querySelectorAll('.insta-card');
      if (cards) {
        gsap.fromTo(
          cards,
          { y: 40, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.6,
            stagger: 0.1,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: sectionRef.current,
              start: 'top 80%',
              toggleActions: 'play none none reverse',
            },
          }
        );
      }
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className="relative w-full py-24 md:py-32 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-16 md:mb-20">
          <span className="inline-block text-xs tracking-[0.2em] uppercase text-primary-500 font-label mb-4">
            Inspire-se
          </span>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-light text-foreground-900 leading-tight">
            Inspire-se com <span className="italic">nossas viagens</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {mockInstagramPosts.map((post, i) => (
            <a
              key={i}
              href={post.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="insta-card group relative block aspect-square overflow-hidden rounded-xl cursor-pointer"
            >
              <img
                src={post.image}
                alt={post.alt}
                className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-500 flex flex-col items-center justify-center gap-3">
                <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-500 transform translate-y-2 group-hover:translate-y-0">
                  <i className="ri-instagram-line text-white text-3xl"></i>
                </div>
                <span className="opacity-0 group-hover:opacity-100 transition-all duration-500 text-white text-sm font-light tracking-wide transform translate-y-2 group-hover:translate-y-0 delay-75">
                  Ver postagem
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="https://www.instagram.com/aoredordomundoviagens_/"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-3 px-8 py-4 bg-accent-500 text-white rounded-full text-sm font-medium tracking-wide hover:bg-accent-600 transition-all duration-500 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-instagram-line text-lg"></i>
            Ver mais no Instagram
          </a>
        </div>
      </div>
    </section>
  );
}